import {Component, Inject, OnInit} from '@angular/core';
import {permissions} from "../../../permissions";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material";

@Component({
  selector: 'app-merge-confirmation-modal',
  templateUrl: './merge-confirmation-modal.component.html',
  styleUrls: ['./merge-confirmation-modal.component.scss'],

})

export class MergeConfirmationModalComponent implements OnInit {

  public  permissions = permissions;

  constructor(
      public dialogRef: MatDialogRef<MergeConfirmationModalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog,

  ) {


  }

  ngOnInit() {
  }

  mergeCustomer() {

  }

  closeDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/merge-customers/merge-confirmation-modal/merge-confirmation-modal.component.ts